import FormContainer from "@client/content/controls/Form/container";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo, type FormHandles } from "@client/controls/Form/component";
import TextArea from "@client/controls/Inputs/TextArea/component";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { useI18n } from "@common/hooks/i18n";
import { identity } from "lodash";
import * as React from "react";
import { withOnSubmit } from "../../hooks";

export type MapProps = WithIsVisibleHOCProps & RootContainerProps;

export interface ActionProps {}

export type Props = ActionProps & MapProps;

export default withIsVisibleHOC((props: Props) => {
  const i18n = useI18n();

  const ref = withOnSubmit<FormHandles>(identity);

  const fields: FormFieldInfo[] = [
    {
      name: "comment",
      label: i18n.comment,
      Component: TextArea,
      componentOpts: {
        rows: 5,
        placeholder: i18n.orderCommentPlaceholder
      },
      qa: "Comment"
    }
  ];

  return (
    <div className="additional_information">
      <h4>{i18n.additionalInfo}</h4>

      <FormContainer {...getRootContainerProps(props)} ref={ref} fields={fields} validateOn="change" />
    </div>
  );
});
